import type { ReactNode } from "react";

/** Shared look for every chart on the tab, so they read as one instrument. */
export const AXIS = { fill: "#7d8794", fontSize: 10 } as const;
export const GRID = "#1e2329";
export const UP = "#26a69a";
export const DOWN = "#ef5350";
export const ACCENT = "#4c8dff";
export const DIM = "#7d8794";
export const TOOLTIP = {
  contentStyle: {
    background: "#12151a",
    border: "1px solid #1e2329",
    borderRadius: 4,
    fontSize: 11,
    color: "#d7dce3",
  },
  itemStyle: { color: "#d7dce3" },
  labelStyle: { color: "#7d8794" },
} as const;

export function Card({
  title,
  subtitle,
  height = 300,
  right,
  children,
}: {
  title: string;
  subtitle?: string;
  height?: number | "auto";
  right?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="border border-term-edge rounded bg-term-panel">
      <header className="flex items-start gap-3 px-3 pt-2 pb-1">
        <div className="min-w-0">
          <h3 className="text-[12px] text-term-text">{title}</h3>
          {subtitle && <p className="text-[10px] leading-relaxed text-term-dim">{subtitle}</p>}
        </div>
        <div className="flex-1" />
        {right}
      </header>
      <div className="px-2 pb-2" style={height === "auto" ? undefined : { height }}>
        {children}
      </div>
    </section>
  );
}

export function Pick<T extends string>({
  value,
  options,
  onChange,
}: {
  value: T;
  options: readonly T[];
  onChange: (v: T) => void;
}) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value as T)}
      className="bg-term-bg border border-term-edge rounded px-1.5 py-0.5 text-[11px] outline-none focus:border-term-accent"
    >
      {options.map((o) => (
        <option key={o}>{o}</option>
      ))}
    </select>
  );
}
